<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newLTA">mdi-plus</v-icon>
          <v-icon v-else-if="queryLTA">mdi-magnify</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newLTA">Create New LTA Parameter</v-toolbar-title>
          <v-toolbar-title v-else-if="queryLTA">View LTA Parameter</v-toolbar-title>
          <v-toolbar-title v-else>Edit LTA Parameter</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newLTA">
                <v-text-field
                  v-model="ltaParamForm.insLtarefNo"
                  :label="labels.insLtarefNo"
                  :error-messages="errors.collect('insLtarefNo')"
                  data-vv-name="insLtarefNo"
                  :data-vv-as="labels.insLtarefNo"
                  v-validate="'required|param|max:5'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.insLtarefNo }}</v-subheader>
                <span>{{ ltaParamForm.insLtarefNo }}</span>
              </v-flex>
              <!-- <v-flex xs6 v-if="newLTA">
                <v-text-field v-model="ltaParamForm.batchNo" :label="labels.batchNo" :error-messages="errors.collect('batchNo')" data-vv-name="batchNo" :data-vv-as="labels.batchNo" readonly ></v-text-field>
              </v-flex> -->
              <v-flex xs6 v-if="!newLTA">
                <v-subheader class="queryLabel">{{ labels.batchNo }}</v-subheader>
                <span>{{ ltaParamForm.batchNo }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="!queryLTA">
                <cal-picker
                  v-model="ltaParamForm.impLtadate"
                  :label="labels.impLtadate"
                  :data-vv-as="labels.impLtadate"
                  data-vv-name="impLtadate"
                  :error-messages="errors.collect('impLtadate')"
                  v-validate="'required'"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.impLtadate }}</v-subheader>
                <span>{{ formatDisplayDate(ltaParamForm.impLtadate) }}</span>
              </v-flex>
              <!-- <v-flex xs6 v-if="newLTA">
                <cal-picker v-model="ltaParamForm.upldDate" :label="labels.upldDate" :data-vv-as="labels.upldDate" data-vv-name="upldDate" :error-messages="errors.collect('upldDate')" readonly></cal-picker>
              </v-flex> -->
              <v-flex xs6 v-if="!newLTA">
                <v-subheader class="queryLabel">{{ labels.upldDate }}</v-subheader>
                <span>{{ formatDisplayDate(ltaParamForm.upldDate) }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="!queryLTA">
                <v-autocomplete
                  :label="labels.defBranch"
                  :items="branchList"
                  v-model="ltaParamForm.defBranch"
                  item-text="label"
                  item-value="value"
                  data-vv-name="defBranch"
                  :data-vv-as="labels.defBranch"
                  :error-messages="errors.collect('defBranch')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.defBranch }}</v-subheader>
                <span>{{ ltaParamForm.defBranch }}</span>
              </v-flex>
              <v-flex xs6 v-if="!queryLTA">
                <v-text-field
                  v-model="ltaParamForm.inclPolType"
                  :label="labels.inclPolType"
                  :error-messages="errors.collect('inclPolType')"
                  data-vv-name="inclPolType"
                  :data-vv-as="labels.inclPolType"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList()"
                  v-validate="'required'"
                  persistent-hint
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.inclPolType }}</v-subheader>
                <span>{{ ltaParamForm.inclPolType }}</span>
              </v-flex>
              <v-flex xs6 v-if="!queryLTA">
                <v-text-field
                  v-model="ltaParamForm.perLTA"
                  :label="labels.perLTA"
                  :error-messages="errors.collect('perLTA')"
                  data-vv-name="perLTA"
                  :data-vv-as="labels.perLTA"
                  append-icon="mdi-magnify"
                  @click:append="getHelpListLTA()"
                  persistent-hint
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.perLTA }}</v-subheader>
                <span>{{ ltaParamForm.perLTA }}</span>
              </v-flex>
              <v-flex xs6 v-if="!queryLTA">
                <v-text-field
                  v-model="ltaParamForm.busCls"
                  :label="labels.busCls"
                  :error-messages="errors.collect('busCls')"
                  data-vv-name="busCls"
                  :data-vv-as="labels.busCls"
                  append-icon="mdi-magnify"
                  @click:append="getHelpListBusCls()"
                  persistent-hint
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
                <span>{{ ltaParamForm.busCls }}</span>
              </v-flex>
              <v-flex xs6 v-if="!queryLTA">
                  <v-text-field
                    v-model="ltaParamForm.coRefLTA"
                    :label="labels.coRefLTA"
                    :error-messages="errors.collect('coRefLTA')"
                    data-vv-name="coRefLTA"
                    :data-vv-as="labels.coRefLTA"
                    v-validate="'required|max:8'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.coRefLTA }}</v-subheader>
                <div class="subheading">{{ ltaParamForm.coRefLTA }}</div>
            </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="!queryLTA">
                <v-checkbox
                  v-model="ltaParamForm.endtDateLess1day"
                  :label="labels.endtDateLess1day"
                  :error-messages="errors.collect('endtDateLess1day')"
                  data-vv-name="endtDateLess1day"
                  :data-vv-as="labels.endtDateLess1day"
                  hide-details
                ></v-checkbox>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.endtDateLess1day }}</v-subheader>
                <span>{{ ltaParamForm.endtDateLess1day ? 'Yes' : 'No' }}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap v-if="!newLTA">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdName }}</v-subheader>
                <div class="queryValue">{{ ltaParamForm.createdName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(ltaParamForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newLTA">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedName }}</v-subheader>
                <div class="queryValue">{{ ltaParamForm.modifiedName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(ltaParamForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-btn v-if="!queryLTA" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
          Save LTA Param
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card>
      <v-dialog v-model="polTypeHelplist" width="900px" persistent>
        <pol-type-helplist :polType="ltaParamForm.inclPolType" @close="doClose" @doAssign="doAssign($event)"></pol-type-helplist>
      </v-dialog>
      <v-dialog v-model="perLTAHelplist" width="900px" persistent>
        <PerLTAHelplist :perLTA="ltaParamForm.perLTA" @close="doClose" @doAssignLTA="doAssignLTA($event)"></PerLTAHelplist>
      </v-dialog>
      <v-dialog v-model="busClsHelplist" width="900px" persistent>
        <BusClsHelplist v-if="busClsHelplist" :busCls="ltaParamForm.busCls" :polType="ltaParamForm.inclPolType" @close="doClose" @doAssignBusCls="doAssignBusCls($event)"></BusClsHelplist>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import PolTypeHelplist from './PolTypeHelplist'
import PerLTAHelplist from './PerLTAHelplist'
import BusClsHelplist from './BusClsHelplist'

export default {
  data() {
    return {
      labels: {
        // General
        insLtarefNo: 'Insurance Company LTA Ref no.',
        batchNo: 'Batch no.',
        impLtadate: 'Implementation Date',
        upldDate: 'Last Upload Date',
        defBranch: 'Default Branch',
        inclPolType: 'Include Policy Type',
        perLTA: 'Permitted Users able to submit to LTA-ADEX',
        busCls: 'Motor Trade Business Classes',
        endtDateLess1day: 'Store endorsement date less 1 day',
        createdName: 'Created By',
        createdDate: 'Creatde Date',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date',
        coRefLTA: 'LTA Reference Code'
      },
      ltaParamForm: {
        // General
        insLtarefNo: undefined,
        batchNo: undefined,
        impLtadate: undefined,
        upldDate: undefined,
        defBranch: undefined,
        inclPolType: undefined,
        perLTA: undefined,
        busCls: '',
        endtDateLess1day: false,
        createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedName: undefined,
        modifiedDate: undefined,
        coRefLTA: undefined,
        busClsMotTrade: undefined
      },
      branchList: [],
      newLTA: false,
      queryLTA: false,
      loading: false,
      polTypeHelplist: false,
      perLTAHelplist: false,
      busClsHelplist: false,
      submitting: false
    }
  },
  computed: {
    insLtarefNo() {
      return this.$route.params.insLtarefNo
    },
    mode() {
      return this.$route.params.mode
    },
    menu() {
      return this.$store.state.uwMotorParam.menu
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.menu.getLTAParam
      if (apiURI) {
        this.loading = true
        try {
          const expand = { insLtarefNo: this.insLtarefNo }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // General
            this.ltaParamForm.insLtarefNo = data.ltaParam.insLtarefNo
            this.ltaParamForm.batchNo = data.ltaParam.batchNo
            this.ltaParamForm.impLtadate = data.ltaParam.impLtadate
            this.ltaParamForm.upldDate = data.ltaParam.upldDate
            this.ltaParamForm.defBranch = data.ltaParam.defBranch
            this.ltaParamForm.inclPolType = data.ltaParam.inclPolType
            this.ltaParamForm.endtDateLess1day = data.ltaParam.endtDateLess1day
            this.ltaParamForm.createdName = data.ltaParam.createdName
            this.ltaParamForm.createdDate = data.ltaParam.createdDate
            this.ltaParamForm.modifiedName = data.ltaParam.modifiedName
            this.ltaParamForm.modifiedDate = data.ltaParam.modifiedDate
            this.ltaParamForm.coRefLTA = data.ltaParam.coRefLTA
            this.ltaParamForm.perLTA = data.ltaParam.perLTA
            this.ltaParamForm.busCls = data.ltaParam.busClsMotTrade
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getBranchList() {
      const apiURI = this.menu.getBranchList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          data.map((brn) => {
            const convertList = {
              label: brn.branch + ' - ' + brn.brnDesc,
              value: brn.branch
            }
            this.branchList.push(convertList)
          })
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newLTA) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createLTAParam
      if (apiURI) {
        this.submitting = true
        try {
          this.ltaParamForm.busClsMotTrade = this.ltaParamForm.busCls
          const result = await this.$http.post(apiURI, this.ltaParamForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'ltaParam' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateLTAParam
      if (apiURI) {
        this.submitting = true
        try {
          this.ltaParamForm.busClsMotTrade = this.ltaParamForm.busCls
          const result = await this.$http.put(apiURI, this.ltaParamForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'ltaParam' })
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    getHelpList() {
      this.polTypeHelplist = true
    },
    getHelpListLTA() {
      this.perLTAHelplist = true
    },
    getHelpListBusCls() {
      this.busClsHelplist = true
    },
    doAssign(Obj) {
      if (Obj.selectedItems.length === Obj.totalLength) {
        this.ltaParamForm.inclPolType = 'All'
      } else {
        this.ltaParamForm.inclPolType = []
        this.ltaParamForm.inclPolType = Obj.selectedItems.toString()
      }
      this.polTypeHelplist = false
    },
    doAssignLTA(Obj) {
      if (Obj.selectedItems.length === Obj.totalLength) {
        this.ltaParamForm.perLTA = 'All'
      } else {
        this.ltaParamForm.perLTA = []
        this.ltaParamForm.perLTA = Obj.selectedItems.toString()
      }
      this.perLTAHelplist = false
    },
    doAssignBusCls(Obj) {
      if (Obj.selectedItems.length === Obj.totalLength) {
        this.ltaParamForm.busCls = 'All'
      } else {
        this.ltaParamForm.busCls = []
        this.ltaParamForm.busCls = Obj.selectedItems.toString()
      }
      this.busClsHelplist = false
    },
    doClose() {
      this.polTypeHelplist = false
      this.perLTAHelplist = false
      this.busClsHelplist = false
    }
  },
  created() {
    this.getBranchList()
    if (this.mode === 'new') {
      this.newLTA = true
      this.queryLTA = false
    } else {
      this.doFetch()
      if (this.mode === 'edit') {
        this.newLTA = false
        this.queryLTA = false
      } else {
        this.newLTA = false
        this.queryLTA = true
      }
    }
  },
  watch: {
    'ltaParamForm.inclPolType': function (value) {
      if (this.newLTA) {
        if (this.ltaParamForm.inclPolType !== '') {
          this.$validator.validate('inclPolType')
        }
      } else {
        if (this.ltaParamForm.inclPolType !== '') {
          this.$validator.validateAll()
        }
      }
    },
    'ltaParamForm.perLTA': function (value) {
      if (this.newLTA) {
        if (this.ltaParamForm.perLTA !== '') {
          this.$validator.validate('perLTA')
        }
      } else {
        if (this.ltaParamForm.perLTA !== '') {
          this.$validator.validateAll()
        }
      }
    },
    'ltaParamForm.busCls': function (value) {
      if (this.newLTA) {
        if (this.ltaParamForm.busCls !== '') {
          this.$validator.validate('busCls')
        }
      } else {
        if (this.ltaParamForm.busCls !== '') {
          this.$validator.validateAll()
        }
      }
    }
  },
  components: {
    PolTypeHelplist,
    PerLTAHelplist,
    BusClsHelplist
  },
  mixins: [MessageMixin]
}
</script>
